/**
 * created by yxy
 * 任务列表
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../base/BaseComponent";
import {Button, DatePicker, Icon, Input, Popover, Select, Tabs,Table} from 'antd';
import '../css/Interview.css';
import InterList from '../view/interList'
const { TabPane } = Tabs;


export default class InterviewTasks extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            selectedKeys: [],
            tabBarList: [
                {
                    key: '0',
                    name: '任务列表',
                    component: <InterList/>,
                },
                // {
                //     key: '1',
                //     name: '专题项目',
                //     permissionsCode: "InterviewTask_creator",
                //     component: <InterList/>,
                // },

            ],
            current:'0',
            taskName:''
        };
    }

    componentWillMount() {
        let taskName = this.props.match.params.differentTake;
        this.setState({taskName:taskName})
        // 从this里面拿到权限码的列表，然后去重构tabBarList  this.permissionCheck
        let {tabBarList} = this.state;
        let newTabs = [];
        tabBarList.forEach(item=>{
            if(item.permissionsCode) {
                if(this.permissionCheck(item.permissionsCode)) {
                    newTabs.push(item)
                }
            } else {
                newTabs.push(item)
            }
        })
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <div className="card-container" style={{marginTop: '15px', marginLeft: '15px'}} id={"InterviewTasks"}>
                {/*选项卡*/}
                {this.renderTabBar()}
                {this.state.current==='0'?<InterList taskName={this.state.taskName}></InterList>:null}

            </div>
        )
    }
    renderTabBar = () => {
        return (
            <Tabs type="card" onChange={this.changeTabBar} style={{fontSize: 16}} activeKey={this.state.current}>
                {
                    this.state.tabBarList.map((item) => {
                        return (
                            <TabPane tab={item.name} key={item.key} style={{backgroundColor: '#fff'}}/>
                        )
                    })
                }
            </Tabs>
        )
    };
    changeTabBar=(value)=>{
       this.setState({current:value},()=>{

       })
    }


}
